import axios from 'axios'

const S3_CLIENT = {
  baseURL: ''
}

export default {
  client: axios.create(S3_CLIENT),
}
